import ActionTypes from '../constants/actionTypes'

const initialState = {
  loading: false,
  sizes: [],
}

export default function sizes(state = initialState, action) {
  let { payload } = action
  switch (action.type) {
    case ActionTypes.GET_SIZE.REQUEST:
      return {
        ...state,
        loading: true,
      }
    case ActionTypes.GET_SIZE.SUCCESS:
      return {
        ...state,
        sizes: [...payload.data],
        loading: false,
      }
    case ActionTypes.GET_SIZE.FAILURE:
      return {
        ...state,
        loading: false,
      }
    case ActionTypes.FORMAT_SIZE.REQUEST:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
